import type {
  SurveyQuestion,
  SurveyQuestionType,
} from '@percent/domain/volunteering'

/** How to handle Remove when only one question remains: deactivate (edit / persisted) or clear (create). */
export type LastQuestionRemoval = 'deactivate' | 'clear'

export interface QuestionBuilderProps {
  questions: SurveyQuestion[]
  onChange: (questions: SurveyQuestion[]) => void
  errors?: Array<{ label?: string } | undefined>
  touched?: Array<{ label?: boolean } | undefined>
  setFieldTouched?: (field: string, touched: boolean) => void
  onDeactivateRequest?: (index: number, onConfirm: () => void) => void
  onActivateRequest?: (index: number, onConfirm: () => void) => void
  allowedQuestionTypes?: SurveyQuestionType[]
  maxQuestions?: number
  questionsFieldName?: 'surveyQuestions' | 'preEventSurveyQuestions'
  lastQuestionRemoval?: LastQuestionRemoval
}

export const MAX_QUESTIONS = 30

export interface QuestionBuilderTextProps {
  headerTitle: string
  headerDescription: string
  addQuestionButton: string
  defaultRatingMinLabel: string
  defaultRatingMaxLabel: string
  // Props for QuestionCard
  typeLabel: string
  questionLabel: string
  requiredLabel: string
  questionPreviewLabel: string
  selectTypePlaceholder: string
  ratingQuestionPlaceholder: string
  freeTextQuestionPlaceholder: string
  removeButton: string
  ratingTypeLabel: string
  freeTextTypeLabel: string
  activeBadgeLabel: string
  deactivatedBadgeLabel: string
  questionResponseSummaryByIndex?: Partial<Record<number, string>>
  deactivateButtonLabel: string
  activateButtonLabel: string
}
